// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3UM1y","alertIcon":"ConfirmModal_alertIcon__1qbK3"};